import Card from "@mui/material/Card";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import React from "react";
import MenuItem from "@mui/material/MenuItem";
import {IoIosLogIn} from "react-icons/io";
import {
    AiOutlineBlock,
    AiOutlineMinusSquare,
    AiOutlinePlusSquare,
    AiTwotoneTag,
    AiOutlineSolution,
    AiOutlineDollar
} from "react-icons/ai";
import {GoBook} from "react-icons/go";
import Hidden from "@mui/material/Hidden";

import {BsGlobeAmericas} from "react-icons/bs";
import {LuChartBarIncreasing, LuChartLine, LuPuzzle, LuAlignLeft, LuNewspaper, LuScanLine, LuSquareActivity, LuGauge, LuGlasses, LuFlaskConical} from "react-icons/lu";
import {TbLambda} from "react-icons/tb";
import {MdOutlineCleaningServices} from "react-icons/md";
import {GiConvergenceTarget} from "react-icons/gi";

export default function MobileMarketingMenu() {


    const [showPlanTheGrowthExpand, setShowPlanTheGrowthExpand] = React.useState(false)
    const [showTellTheStoryExpand, setShowTellTheStoryExpand] = React.useState(false)
    const [showFixTheDataExpand, setShowFixTheDataExpand] = React.useState(false)
    const [showRunTheBusinessExpand, setShowRunTheBusinessExpand] = React.useState(false)

    const handlePlanTheGrowthExpand = () => {
        setShowPlanTheGrowthExpand(!showPlanTheGrowthExpand)
    }

    const handleTellTheStoryExpand = () => {
        setShowTellTheStoryExpand(!showTellTheStoryExpand)
    }

    const handleFixTheDataExpand = () => {
        setShowFixTheDataExpand(!showFixTheDataExpand)
    }

    const handleRunTheBusinessExpand = () => {
        setShowRunTheBusinessExpand(!showRunTheBusinessExpand)
    }

    return (
        <Card sx={{padding: "10px", width: "100%"}}>
            <Hidden mdUp>
                <MenuItem component="a"
                          href="/login">
                    <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                        <IoIosLogIn size="1.25em"/>
                    </ListItemIcon>
                    <ListItemText primary="Sign in"/>
                </MenuItem>
            </Hidden>

            <MenuItem disableRipple={true}
                      style={{borderTop: '1px dotted #000'}}
                      component="a"
                      href="/use-cases/fix-the-data"
                      onClick={handleFixTheDataExpand}>
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <LuPuzzle size="1em"/>
                </ListItemIcon>
                <ListItemText primary="Fix the Data"
                              secondary="Unify GTM and Finance data the right way"/>
                <ListItemIcon onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleFixTheDataExpand();
                }}>{!showFixTheDataExpand ? <AiOutlinePlusSquare size="1.25em"/> :
                    <AiOutlineMinusSquare size="1.25em"/>}</ListItemIcon>
            </MenuItem>

            {showFixTheDataExpand &&
                <React.Fragment>
                    <MenuItem component="a"
                              href="/products/next-gen-data-assembly">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <TbLambda size="1em"/>
                        </ListItemIcon>
                        <ListItemText primary="Data Assembly"
                                      secondary="ETL-free data assembly that just works"/>
                    </MenuItem>

                    <MenuItem component="a"
                              href="/products/data-hygiene">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <MdOutlineCleaningServices size="1em"/>
                        </ListItemIcon>
                        <ListItemText primary="Data Hygiene"
                                      secondary="Always-on hygiene & tools for one-time cleanup"/>
                    </MenuItem>

                    <MenuItem component="a"
                              href="/products/multiple-crms">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <GiConvergenceTarget size="1em"/>
                        </ListItemIcon>
                        <ListItemText primary="Multi-CRM"
                                      secondary="Multiple CRMs, one source of truth"/>
                    </MenuItem>
                </React.Fragment>
            }

            <MenuItem disableRipple={true}
                      style={{borderTop: '1px dotted #000'}}
                      component="a"
                      href="/use-cases/plan-the-growth"
            >
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <LuFlaskConical size="1em"/>
                </ListItemIcon>
                <ListItemText primary="Plan the Growth"
                              secondary="Create and manage growth scenarios"/>
                <ListItemIcon onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handlePlanTheGrowthExpand();
                }}>{!showPlanTheGrowthExpand ? <AiOutlinePlusSquare size="1.25em"/> :
                    <AiOutlineMinusSquare size="1.25em"/>}</ListItemIcon>
            </MenuItem>

            {showPlanTheGrowthExpand &&
                <React.Fragment>
                    <MenuItem component="a"
                              href="/products/multi-quarter-projections">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <LuChartBarIncreasing size="1em"/>
                        </ListItemIcon>
                        <ListItemText primary="Growth Scenarios"
                                      secondary="Integrated, rolling growth scenarios"/>
                    </MenuItem>

                    <MenuItem component="a"
                              href="/products/forecasting">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <LuGlasses size="1em"/>
                        </ListItemIcon>
                        <ListItemText primary="Sales Forecasting"
                                      secondary="Best-practice forecast submission orchestration"/>
                    </MenuItem>

                    <MenuItem component="a"
                              href="/products/performance-drivers">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <LuSquareActivity size="1em"/>
                        </ListItemIcon>
                        <ListItemText primary="Performance Driver Analysis"
                                      secondary="On-the-fly key performance drivers analysis"/>
                    </MenuItem>
                </React.Fragment>
            }

            <MenuItem disableRipple={true}
                      style={{borderTop: '1px dotted #000'}}
                      component="a"
                      href="/use-cases/run-the-business"
                      onClick={handleRunTheBusinessExpand}>
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <LuAlignLeft size="1em"/>
                </ListItemIcon>
                <ListItemText primary="Run the Business"
                              secondary="Monitor and optimize business operations"/>
                <ListItemIcon onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleRunTheBusinessExpand();
                }}>{!showRunTheBusinessExpand ? <AiOutlinePlusSquare size="1.25em"/> :
                    <AiOutlineMinusSquare size="1.25em"/>}</ListItemIcon>
            </MenuItem>

            {showRunTheBusinessExpand &&
                <React.Fragment>
                    <MenuItem component="a"
                              href="/products/business-digest">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <LuNewspaper size="1em"/>
                        </ListItemIcon>
                        <ListItemText primary="Business Digests"
                                      secondary="Monday-morning insights delivered to teams where they work"/>
                    </MenuItem>

                    <MenuItem component="a"
                              href="/products/qpilot">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <LuScanLine size="1em"/>
                        </ListItemIcon>
                        <ListItemText primary="AI Variance Analysis"
                                      secondary="Daily agentic analysis of business metrics across core segments"/>
                    </MenuItem>
                </React.Fragment>
            }

            <MenuItem disableRipple={true}
                      style={{borderTop: '1px dotted #000'}}
                      component="a"
                      href="/use-cases/tell-the-story"
                      onClick={handleTellTheStoryExpand}>
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <LuChartLine size="1em"/>
                </ListItemIcon>
                <ListItemText primary="Tell the Story"
                              secondary="Communicate business performance effectively"/>
                <ListItemIcon onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleTellTheStoryExpand();
                }}>{!showTellTheStoryExpand ? <AiOutlinePlusSquare size="1.25em"/> :
                    <AiOutlineMinusSquare size="1.25em"/>}</ListItemIcon>
            </MenuItem>

            {showTellTheStoryExpand &&
                <React.Fragment>
                    <MenuItem component="a"
                              href="/products/go-to-market-stats#gtm-reporting-packages">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <LuChartBarIncreasing size='1em'/>
                        </ListItemIcon>
                        <ListItemText primary="GTM Stats"
                                      secondary="Capture core GTM stats, automatically"/>
                    </MenuItem>

                    <MenuItem component="a"
                              href="/products/go-to-market-stats#core-stats">
                        <ListItemIcon style={{width: '2em', minWidth: '1.5em'}}>
                            <LuGauge size='1em'/>
                        </ListItemIcon>
                        <ListItemText primary="Core Efficiency Stats"
                                      secondary="Track and analyze key efficiency metrics"/>
                    </MenuItem>
                </React.Fragment>
            }

            <Hidden mdUp> <MenuItem component="a"
                                    style={{borderTop: '1px dotted #000'}}
                                    href="/solutions/finance">
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <AiOutlineDollar size={"1em"}/>
                </ListItemIcon>
                <ListItemText primary="For Finance"/>
            </MenuItem>
            </Hidden>

            <Hidden mdUp> <MenuItem component="a"
                                    style={{borderTop: '1px dotted #000'}}
                                    href="/solutions/revenue-operations">
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <AiOutlineSolution size={"1em"}/>
                </ListItemIcon>
                <ListItemText primary="For RevOps"/>
            </MenuItem>
            </Hidden>


            <Hidden mdUp> <MenuItem component="a"
                                    style={{borderTop: '1px dotted #000'}}
                                    href="/pricing">
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <AiTwotoneTag size={"1em"}/>
                </ListItemIcon>
                <ListItemText primary="Pricing"/>
            </MenuItem>
            </Hidden>

            <Hidden mdUp> <MenuItem component="a"
                                    style={{borderTop: '1px dotted #000'}}
                                    href="/partners">
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <AiOutlineBlock size={"1em"}/>
                </ListItemIcon>
                <ListItemText primary="Partners"/>
            </MenuItem>
            </Hidden>
            <Hidden mdUp> <MenuItem component="a"
                                    style={{borderTop: '1px dotted #000'}}
                                    href="/about">
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <BsGlobeAmericas size={"1em"}/>
                </ListItemIcon>
                <ListItemText primary="About"/>
            </MenuItem>
            </Hidden>

            <Hidden mdUp> <MenuItem component="a"
                                    style={{borderTop: '1px dotted #000'}}
                                    href="https://blog.qflow.ai">
                <ListItemIcon style={{width: '2em', minWidth: '2em'}}>
                    <GoBook size={"1em"}/>
                </ListItemIcon>
                <ListItemText primary="Blog"/>
            </MenuItem>
            </Hidden>
        </Card>
    )
}